import { render, staticRenderFns } from "./InHealthSetting.vue?vue&type=template&id=5a4c1716&scoped=true"
import script from "./InHealthSetting.vue?vue&type=script&lang=js"
export * from "./InHealthSetting.vue?vue&type=script&lang=js"
import style0 from "./InHealthSetting.vue?vue&type=style&index=0&id=5a4c1716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c1716",
  null
  
)

export default component.exports